
import { motion } from "framer-motion";
import { HugeiconsIcon } from "@hugeicons/react";
import { ArrowLeft01Icon } from "@hugeicons/core-free-icons";
import { AnimatedText } from "../ui/animated-text";

interface ImpressumProps {
    onClose: () => void;
}

export function Impressum({ onClose }: ImpressumProps) {
    return (
        <div className="min-h-screen text-white py-20 px-6">
            <div className="container mx-auto max-w-4xl">
                <motion.button
                    onClick={onClose}
                    className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors mb-8"
                >
                    <HugeiconsIcon icon={ArrowLeft01Icon} size={16} />
                    Zurück zur Startseite
                </motion.button>

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                >
                    <AnimatedText
                        lines={["Impressum"]}
                        className="text-4xl md:text-5xl font-bold mb-12"
                        direction="up"
                        as="h1"
                    />

                    <div className="space-y-8 text-gray-300">
                        <section>
                            <h2 className="text-2xl font-bold text-white mb-4">Angaben gemäß § 5 TMG</h2>
                            <div className="space-y-2">
                                <p>
                                    <strong className="text-white">Firmenname:</strong><br />
                                    VBS Taximeter Datensicherung GmbH
                                </p>
                                <p>
                                    <strong className="text-white">Anschrift:</strong><br />
                                    Buckower Chaussee 110–113<br />
                                    12277 Berlin-Marienfelde<br />
                                    Deutschland
                                </p>
                            </div>
                        </section>

                        <section>
                            <h2 className="text-2xl font-bold text-white mb-4">Geschäftsführung</h2>
                            <p>
                                <strong className="text-white">Geschäftsführer:</strong><br />
                                Aziz Özer
                            </p>
                        </section>

                        <section>
                            <h2 className="text-2xl font-bold text-white mb-4">Registereintrag</h2>
                            <div className="space-y-2">
                                <p>
                                    <strong className="text-white">Handelsregister:</strong><br />
                                    HRB 178506 B
                                </p>
                                <p>
                                    <strong className="text-white">Registergericht:</strong><br />
                                    Amtsgericht Berlin-Charlottenburg
                                </p>
                                <p>
                                    <strong className="text-white">EUID:</strong><br />
                                    DEF1103R.HRB178506B
                                </p>
                                <p>
                                    <strong className="text-white">Gründungsdatum:</strong><br />
                                    20. Juli 2016
                                </p>
                            </div>
                        </section>

                        <section>
                            <h2 className="text-2xl font-bold text-white mb-4">Kontakt</h2>
                            <div className="space-y-2">
                                <p>
                                    <strong className="text-white">Telefon:</strong><br />
                                    <a href="tel:+4930959982020" className="hover:text-white transition-colors">030 959982020</a><br />
                                    <span className="text-gray-400 text-sm">Mo-Fr: 10-15 Uhr</span>
                                </p>
                                <p>
                                    <strong className="text-white">E-Mail:</strong><br />
                                    <a href="mailto:support@taxifusion.de" className="hover:text-white transition-colors">support@taxifusion.de</a>
                                </p>
                                <p className="mt-4">
                                    Bei Fragen können Sie uns gerne über die oben genannten Kontaktmöglichkeiten erreichen.
                                </p>
                            </div>
                        </section>

                        <section>
                            <h2 className="text-2xl font-bold text-white mb-4">Haftungsausschluss</h2>
                            <div className="space-y-4">
                                <div>
                                    <h3 className="text-xl font-semibold text-white mb-2">Haftung für Inhalte</h3>
                                    <p>
                                        Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.
                                        Sollten Ihnen rechtswidrige Inhalte auffallen, bitten wir um einen entsprechenden Hinweis.
                                    </p>
                                </div>
                                <div>
                                    <h3 className="text-xl font-semibold text-white mb-2">Haftung für Links</h3>
                                    <p>
                                        Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben.
                                        Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
                                    </p>
                                </div>
                            </div>
                        </section>
                    </div>
                </motion.div>
            </div>
        </div>
    );
}

